import { useCallContext } from '@src/app/voice/ongoing-call/context/useCallContext'
import type VoicePhoneNumberSelectorController from '@src/app/voice/store/VoicePhoneNumberSelectorController'
import type { PhoneNumberModel } from '@src/service/model'
import Typography from '@ui/Typography'

import * as styles from './ExternalParticipantBanner.css'

interface ExternalParticipantBannerProps {
  controller: VoicePhoneNumberSelectorController
  phoneNumber: PhoneNumberModel
  showChange: boolean
  onChange?: (selectedValue: string) => void
}

const ExternalParticipantBanner = ({
  controller,
  phoneNumber,
  showChange,
  onChange,
}: ExternalParticipantBannerProps) => {
  const { call, setOpenConfirmationModal } = useCallContext()
  const displayText = `Once you add the participants, this team call will be converted to ${
    phoneNumber.name
  }${showChange ? '. ' : ''}`

  return (
    <>
      {controller.hasExternalSelections && call.isDirectCall ? (
        <>
          <div className={styles.root}>
            <Typography variant="emoji" className={styles.emoji}>
              {phoneNumber.symbol}
            </Typography>
            <Typography variant="footnote" className={styles.text}>
              {displayText}
              {showChange && (
                <span
                  className={styles.action}
                  onClick={() => setOpenConfirmationModal(true)}
                >
                  Change number
                </span>
              )}
            </Typography>
          </div>
        </>
      ) : null}
    </>
  )
}

export default ExternalParticipantBanner
